import {
  getBaiscMaterial,
  getLinkMaterial,
  getMaterialCategoryV2,
} from '@/api/modules/material';
import { flattenTree } from '@/utils/utils';

flattenTree;

export default {
  namespaced: true,
  state: {
    categoryList: [],
    materialList: [],
    flattenCategoryList: [],
    currentGroupList: [],
    materialCount: 0,
    breadcrumbPath: [0],
    pathList: [],
    queryParams: {
      groupList: [],
      pageIndex: 1,
      pageSize: 10,
      groupId: 0,
      title: '',
      type: [],
    },
    isLoading: false,
    isFinished: false,
  },
  mutations: {
    setGroupPaths(state, breadcrumbPath) {
      state.breadcrumbPath = breadcrumbPath;
    },
    setCategoryList(state, categoryList) {
      state.categoryList = categoryList;
      state.flattenCategoryList = flattenTree(state.categoryList);
    },
    setMaterialList(state, materialList) {
      state.materialList = materialList;
    },

    setMaterialCount(state, count) {
      state.materialCount = count;
    },

    setQueryParams(state, params) {
      state.queryParams = { ...state.queryParams, ...params };
    },

    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },

    setIsFinished(state, isFinished) {
      state.isFinished = isFinished;
    },
    setCurrentGroupData(state, materialList) {
      function getNonExistentItems(array1, array2) {
        const result = array1.filter((item1) => {
          return !array2.some((item2) => item2.id === item1.id);
        });
        return result;
      }
      console.log(state.flattenCategoryList, 'state.queryParams.groupId');
      console.log(state.queryParams.groupId, 'state.queryParams.groupId');
      let currentGroupList = state.flattenCategoryList
        .filter(
          (_) => _.parentId === state.queryParams.groupId && _.groupId !== 0
        )
        .map((_) => {
          return {
            title: _.groupName,
            id: _.groupId,
            type: 5,
            ..._,
          };
        });
      console.log(materialList, 'materialList**');
      console.log(currentGroupList, 'currentGroupList****');
      if (materialList.length) {
        currentGroupList = getNonExistentItems(currentGroupList, materialList);
      }
      state.currentGroupList = currentGroupList;
    },
  },
  actions: {
    // 获取素材列表
    async fetchMaterialList({ commit, state }) {
      try {
        commit('setIsLoading', true);
        const res = await getBaiscMaterial(state.queryParams);
        commit('setIsLoading', false);
        if (res.code === 0) {
          let list = [];
          if (state.queryParams.type && state.queryParams.type.length === 0) {
            commit('setCurrentGroupData', [
              ...res.data.dataList,
              ...state.materialList,
            ]);
            list = [
              ...state.currentGroupList,
              ...state.materialList,
              ...res.data.dataList,
            ];
          } else {
            list = [...state.materialList, ...res.data.dataList];
          }
          commit('setMaterialList', list);
          commit('setMaterialCount', res.data.page.totalCount);
          if (
            list.length + state.currentGroupList ===
            res.data.page.totalCount
          ) {
            commit('setIsFinished', true);
          } else {
            commit('setIsFinished', false);
          }
        }
      } catch (e) {
        commit('setIsLoading', false);
      }
    },

    // 获取下级分组列表
    async fetchMaterialCategoryList({ commit }, params = {}) {
      params.status = 1;
      const res = await getMaterialCategoryV2(params);
      if (res.code === 0) {
        commit('setCategoryList', res.data);
      }
    },

    async fetchLinkMaterialList({ commit, state }) {
      try {
        commit('setIsLoading', true);
        const res = await getLinkMaterial(state.queryParams);
        commit('setIsLoading', false);
        if (res.code === 0) {
          const list = [...state.materialList, ...res.data.dataList];
          commit('setMaterialList', list);
          commit('setMaterialCount', res.data.page.totalCount);
          if (list.length === res.data.page.totalCount) {
            commit('setIsFinished', true);
          } else {
            commit('setIsFinished', false);
          }
        }
      } catch (e) {
        commit('setIsLoading', false);
      }
    },
  },
};
